import styled from 'styled-components';

/** The tab's own white panel, since the audit record has no outer card; the cards space themselves. */
export const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.white};
`;

export const CardError = styled.div`
  padding: 24px;
  text-align: center;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
